import { SvgIcon, Tooltip } from '@mui/material';
import { RiTimeLine } from '@remixicon/react';
import { useLanguage } from '../contexts/language';
import CustomChip from './CustomChip';
import { CrewMemberStatus, VesselStatus } from '../types/core';
import { BADGE_CLASSNAMES } from '../utils/styles';

export type BadgeEntity = 'vessel' | 'crew-member';

interface VesselStatusBadgeProps {
  entity: 'vessel';
  status: VesselStatus;
  small?: boolean;
  className?: string;
}

interface CrewMemberStatusBadgeProps {
  entity: 'crew-member';
  status: CrewMemberStatus;
  small?: boolean;
}

type VesselOrCrewStatusBadgeProps =
  | VesselStatusBadgeProps
  | CrewMemberStatusBadgeProps;

const getChipClasses = (status: VesselStatus | CrewMemberStatus) => {
  switch (status) {
    case VesselStatus.Compliant:
    case CrewMemberStatus.Compliant:
      return BADGE_CLASSNAMES.GREEN;
    case VesselStatus.Uncompliant:
    case CrewMemberStatus.Uncompliant:
      return BADGE_CLASSNAMES.RED;
    default:
      return BADGE_CLASSNAMES.GRAY;
  }
};

const VesselOrCrewStatusBadge = ({
  status,
  small = false,
  entity,
}: VesselOrCrewStatusBadgeProps) => {
  const chipClass = getChipClasses(status);
  const { t } = useLanguage();
  const label = t(`${entity}-status.${status}`);
  return (
    <CustomChip
      label={label}
      className={chipClass}
      small={small}
      title={label}
    />
  );
};

export default VesselOrCrewStatusBadge;

export interface ExpiringSoonBadgeProps {
  className?: string;
  entity?: 'vessel' | 'crew-member';
  inheritColor?: boolean;
}

export const ExpiringSoonBadge = ({
  className,
  entity,
  inheritColor = false,
}: ExpiringSoonBadgeProps) => {
  const { t } = useLanguage();
  return (
    <Tooltip
      title={t('content.expiring-soon-tooltip', {
        ENTITY: t(`content.${entity}`),
      })}
    >
      <span>
        <SvgIcon
          color={inheritColor ? 'inherit' : undefined}
          className={[!inheritColor && 'fill-orange-500', className]
            .filter(Boolean)
            .join(' ')}
          component={RiTimeLine}
          fontSize="small"
        />
      </span>
    </Tooltip>
  );
};
